import styled from "styled-components";
import { media } from "../../theme/theme";
import { PanelWithPreviewBR } from "../V3PanelWithPreview";

export const ItemPreviewDateInputWrapper = styled.div`
    width: 150px;
`;

export const ItemPreviewBtnWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const BR = PanelWithPreviewBR;

export const ItemPreviewSourceDateWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    ${media.custom(BR)} {
        flex-direction: row;
    }

    > div {
        ${media.custom(BR)} {

            width: auto;
            margin-bottom: 0;
        }

        &:first-child {
            width: 100%;
            margin-bottom: 18px;

            ${media.custom(BR)} {
                margin-right: 20px;
                margin-bottom: 0;
            }
        }
    }
`;

export const FFNoticeTooltip = styled.span`
    position: relative;
    top: 3px;
    left: 2px;
`;